import collection from './tag/collection';
import item from './tag/item';

const tag = {
  namespaced: true,
  modules: {
    collection,
    item,
  },
};

export default tag;
